import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { Compass, Home } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { tokens } from '../theme';

const NotFoundPage: React.FC = () => {
  return (
    <Box sx={{ bgcolor: 'background.default', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Navbar />
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          pt: 10,
          pb: 10,
        }}
      >
        <Container maxWidth="sm" sx={{ textAlign: 'center' }}>
          <Box
            sx={{
              width: 72,
              height: 72,
              borderRadius: `${tokens.radiusControl}px`,
              bgcolor: tokens.copperTint,
              color: tokens.copper,
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 3,
            }}
          >
            <Compass size={36} strokeWidth={1.5} />
          </Box>
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: '4rem', md: '6rem' },
              color: 'text.primary',
              mb: 1,
            }}
          >
            404
          </Typography>
          <Typography variant="h3" component="h2" gutterBottom>
            Page Not Found
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            The page you're looking for doesn't exist or has been moved.
          </Typography>
          <Button
            component={RouterLink}
            to="/"
            variant="contained"
            size="large"
            startIcon={<Home size={18} strokeWidth={1.5} />}
          >
            Back to Home
          </Button>
        </Container>
      </Box>
      <Footer />
    </Box>
  );
};

export default NotFoundPage;
